import { render, staticRenderFns } from "./AttributeLabel.vue?vue&type=template&id=1458dcf2&scoped=true"
import script from "./AttributeLabel.vue?vue&type=script&lang=js"
export * from "./AttributeLabel.vue?vue&type=script&lang=js"
import style0 from "./AttributeLabel.vue?vue&type=style&index=0&id=1458dcf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458dcf2",
  null
  
)

export default component.exports